
<form [formGroup]="form">
  <div class="row">
    <div class="col">
      <frm-anlage-facility-no-select
        i18n-label="@@WawiApiNoteFacilityCreateForm_FacilityNo"
        label="Facility No."
        formControlName="facilityNoInternal"
      ></frm-anlage-facility-no-select>
    </div>
  </div>
  <div class="row">
    <div class="col" style="text-align: center;">
      <frm-text
        i18n-label="@@WawiApiNoteFacilityCreateForm_Note"
        label="Note"
        formControlName="note"
        [multiline]="true"
        [rows]="8"
      ></frm-text>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <frm-check
        i18n-label="@@WawiApiNoteFacilityCreateForm_DisplayLevelMobile"
        label="Display on mobile app"
        formControlName="displayLevelMobile"
        [trueValue]="NoteDisplayLevelMobileType.Display"
        [falseValue]="NoteDisplayLevelMobileType.DontDisplay"
      ></frm-check>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label i18n="Anzeigestufe@@WawiApiNoteFacilityCreateForm_DisplayLevel">DisplayLevel</mat-label>
        <mat-select formControlName="displayLevel" >
          @for (item of displayLevel; track item) {
            <mat-option
              [value]="item.value">
              {{item.label}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

</form>